// prefetchUtils.js

export const prefetchComponent = (importFunction) => {
  if (importFunction) {
    importFunction();
  }
};